export default __webpack_public_path__ + "img/23.cd5d44a.svg";